import { IconCheck, IconUserCircle, mapper } from '@maia/icons';
import { ComponentProps } from 'react';
import { Checkbox as AriaCheckbox } from 'react-aria-components';
import { cardStyles, FeaturedIcon, Typography } from '../../../ui';

type RadioCardProps = {
  name: string;
  description?: string;
  icon: string;
} & ComponentProps<typeof AriaCheckbox>;

export function RadioCard(props: RadioCardProps) {
  const { name, description, icon, isDisabled, ...rest } = props;
  return (
    <AriaCheckbox
      className={cardStyles({
        variant: 'elevated',
        className: `group flex items-center px-20 py-24 gap-x-12 cursor-pointer ${isDisabled ? 'opacity-50 cursor-not-allowed' : ''}`,
      })}
      isDisabled={isDisabled}
      {...rest}
    >
      <div className='flex content-center size-16 border border-grayscale300 rounded-4 group-data-[selected="true"]:bg-primaryMain group-data-[selected="true"]:border-primaryMain shrink-0'>
        <IconCheck className="fill-grayscale0" />
      </div>
      <div className="flex items-center gap-x-12 grow">
        <FeaturedIcon variant="light-square" icon={mapper(icon)} />
        <div className="flex flex-col">
          <Typography variant="body-xs" weight="medium">
            {name}
          </Typography>
          {description && (
            <Typography
              variant="body-xs"
              weight="regular"
              className="text-grayscale300 line-clamp-1"
            >
              {description}
            </Typography>
          )}
        </div>
      </div>
      <IconUserCircle className="fill-grayscale300 shrink-0" />
    </AriaCheckbox>
  );
}
